export default __webpack_public_path__ + "static/media/Avatar-8.ea0ed03a.png";